import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import s from './ModalWithActions.scss'


const ModalWithActions = ({ title, name, actions, id, children, onClose }) => (
  <Modal
    className={s.modalWithActions}
    {...{ id, title, name, onClose }}
  >
    {children}
    <div className={s.actions}>
      {
        actions.map((action, index) => (
          <Button key={index} className={s.button} fullWidth lg {...action} />
        ))
      }
    </div>
  </Modal>
)

ModalWithActions.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  actions: PropTypes.array.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.any,
}


export default ModalWithActions
